exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".thumbnail[data-v-d4039940]{display:inline-block;margin:2px;width:50px;height:50px;border-radius:2px;background-position:50%;background-size:cover;box-shadow:inset 0 0 0 1px hsla(0,0%,100%,.2);cursor:pointer;overflow:hidden}.thumbnail.active[data-v-d4039940]{box-shadow:inset 0 0 0 2px #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-d4039940","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./assets/vue/components/images/components/common/thumbnail.styl
// module id = 557
// module chunks = 0